import { render, staticRenderFns } from "./QueryTestSection.vue?vue&type=template&id=b547118c&scoped=true"
import script from "./QueryTestSection.vue?vue&type=script&lang=js"
export * from "./QueryTestSection.vue?vue&type=script&lang=js"
import style0 from "./QueryTestSection.vue?vue&type=style&index=0&id=b547118c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b547118c",
  null
  
)

export default component.exports